export default [
  {
    title: 'Configurações',
    icon: 'SettingsIcon',
    action: 'read',
    resource: 'Customizacao',
    children: [
      {
        title: 'Customização',
        route: 'settings-customization',
        icon: 'SlidersIcon',
        action: 'read',
        resource: 'Customizacao',
      },
      {
        title: 'Preferências',
        route: 'settings-preferencias',
        icon: 'SettingsIcon',
        action: 'read',
        resource: 'Preferencias',
      },
      {
        title: 'Configuração da IA',
        route: 'ai-chat-config',
        icon: 'CpuIcon',
        action: 'manage',
        resource: 'AiChatConfig',
      },
      {
        title: 'Integração ERP',
        route: 'integracao-erp',
        icon: 'ServerIcon',
        action: 'manage',
        resource: 'IntegracaoErp',
      },
      {
        title: 'Jobs de Integração',
        route: 'jobs-erp',
        icon: 'ClockIcon',
        action: 'manage',
        resource: 'IntegracaoErp',
      },
      {
        title: 'Dashboard Integrações',
        route: 'dashboard-integracao',
        icon: 'BarChart2Icon',
        action: 'manage',
        resource: 'IntegracaoErp',
      },
    ],
  },
  {
    title: 'Sistema',
    icon: 'ToolIcon',
    action: 'read',
    resource: 'Sistema',
    children: [
      {
        title: 'Tenants (Clientes)',
        route: 'sistema-tenants',
        icon: 'LayersIcon',
        action: 'manage',
        resource: 'Sistema',
        dkpOnly: true,
      },
      {
        title: 'Usuários',
        route: 'usuarios',
        icon: 'UserIcon',
        action: 'read',
        resource: 'Usuarios',
      },
      {
        title: 'Produtos',
        route: 'apps-produtos-list',
        icon: 'BoxIcon',
        action: 'read',
        resource: 'Produto',
      },
      {
        title: 'Perfil Acesso',
        route: 'perfils',
        icon: 'UsersIcon',
        action: 'read',
        resource: 'PerfilAcesso',
      },
      {
        title: 'Gerenciar Módulos',
        route: 'gerenciar-modulos',
        icon: 'ToggleRightIcon',
        action: 'manage',
        resource: 'GerenciarModulos',
      },
      {
        title: 'Permissões',
        route: 'apps-permissao-list',
        icon: 'UsersIcon',
        action: 'read',
        resource: 'Permissoes',
      },
      {
        title: 'Parâmetros',
        route: 'parametros',
        icon: 'SlidersIcon',
        action: 'manage',
        resource: 'Sistema',
      },
      {
        title: 'Regras',
        route: 'apps-regra-list',
        icon: 'UsersIcon',
        action: 'manage',
        resource: 'Regras',
      },
      {
        title: 'Tabela Extensão',
        route: 'apps-tb-extensao-list',
        icon: 'UsersIcon',
        action: 'manage',
        resource: 'Cliente DKP',
      },
      {
        title: 'Campos Customizados',
        route: 'apps-campos-customizado-list',
        icon: 'UsersIcon',
        action: 'read',
        resource: 'CamposCustomizados',
      },
      // {
      //     title: 'Imagem Login',
      //     route: 'apps-imagem-login-list',
      //     icon: 'UsersIcon',
      //     action: 'read',
      //     resource: 'Sistema',
      // },
      {
        title: 'WorkFlow',
        action: 'read',
        resource: 'WorkFlow',
        children: [
          {
            title: 'WorkFlow Áreas',
            route: 'apps-workflow-list',
            action: 'read',
            resource: 'WorkFlowAreas',
          },
          {
            title: 'WorkFlow X Usuários',
            route: 'apps-workflow-usuario-list',
            action: 'read',
            resource: 'WorkFlowUsuarios',
          },
          {
            title: 'WorkFlow Direcionamento',
            route: 'apps-workflow-direcionamento-list',
            action: 'read',
            resource: 'WorkflowDirecionamento',
          },

        ],
      },

    ],
  },
];
